import React from 'react';
import { motion } from 'framer-motion';

const Disclaimer = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const contactBlock = (
    <div className="bg-[#F9FFF5] border border-[#2E7D32]/20 p-6 rounded-lg mt-2">
      <p><strong>Sam's Nutri Hub</strong></p>
      <p>Venkatesh Prime, 4th Floor, Burudgaon Road</p>
      <p>Ahmednagar, Maharashtra 414001</p>
      <p>Email: <a href="mailto:hello@samsnutrihub.com" className="text-[#2E7D32] hover:underline">hello@samsnutrihub.com</a></p>
      <p>Phone: <a href="tel:+919637375555" className="text-[#2E7D32] hover:underline">+91 96373 75555</a></p>
    </div>
  );

  return (
    <div className="bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.div {...fadeInUp}>
          <p className="text-sm text-[#9E9E9E] mb-2">Last updated: November 1, 2023</p>
          <h1 className="text-4xl font-bold text-[#0B1320] font-poppins mb-10">
            Disclaimer — Sam's Nutri Hub
          </h1>

          <div className="prose prose-lg max-w-none text-[#4A4A4A] leading-relaxed space-y-8">

            <section>
              <p>
                All the information on this website — <strong>samsnutrihub.com</strong> — is published in good faith
                and for general information purposes only. Sam's Nutri Hub does not make any warranties about the
                completeness, reliability, or accuracy of this information. Any action you take upon the information
                you find on this website is strictly at your own risk. Sam's Nutri Hub will not be liable for any
                losses and/or damages in connection with the use of our website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">External Links</h2>
              <p>
                From our website, you can visit other websites by following hyperlinks to such external sites.
                While we strive to provide only quality links to useful and ethical websites, we have no control
                over the content and nature of these sites. These links do not imply a recommendation for all the
                content found on these sites. Site owners and content may change without notice and may occur
                before we have the opportunity to remove a link which may have gone 'bad'.
              </p>
              <p className="mt-4">
                Please be aware that when you leave our website, other sites may have different privacy policies
                and terms which are beyond our control. Please be sure to check the Privacy Policies and Terms of
                Service of those sites before engaging in any business or uploading any information.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">No Medical Advice</h2>
              <p>
                Sam's Nutri Hub and its coaches are nutrition and wellness professionals, not licensed medical
                practitioners. The content on this website is not intended as a substitute for professional
                medical advice, diagnosis, or treatment. Always consult your physician or qualified healthcare
                provider before beginning any new nutrition or exercise program — especially if you have a
                pre-existing medical condition or are taking medications.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">Individual Results</h2>
              <p>
                Results shared on this website — including testimonials, before-and-after photos, and case
                studies — represent individual experiences. Results may vary significantly based on factors
                including personal commitment, genetics, lifestyle, and health status. No specific outcome
                is guaranteed.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">Emergency Situations</h2>
              <div className="bg-red-50 border border-red-200 p-5 rounded-lg">
                <p className="text-red-800">
                  Our services are <strong>not</strong> for medical emergencies. If you are experiencing a
                  medical emergency, call <strong>108</strong> (India) immediately or visit your nearest hospital.
                  Do not rely on this website for urgent medical needs.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">Consent</h2>
              <p>
                By using our website, you hereby consent to this disclaimer and agree to its terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">Updates</h2>
              <p>
                Should we update, amend, or make any changes to this document, those changes will be
                prominently posted here. We encourage you to review this page periodically.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">Contact Us</h2>
              <p>If you have any questions about this disclaimer, please feel free to reach out:</p>
              {contactBlock}
            </section>

          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Disclaimer;